import React from 'react';
import './About.css'
const AboutPage = () => {
  return (
    <div className="about-page">
     <u><h1>About Us</h1></u>
      <p>
        Welcome to XOXO HEALTHCARE, your trusted companion in managing your healthcare needs. We understand that finding the right healthcare professional and scheduling appointments can sometimes be challenging and time-consuming. That's why we've created a seamless platform to simplify this process for you.
      </p>
      <hr/>
      <h2>Our Vision</h2>
      <p>
        We envision a world where accessing quality healthcare is effortless and accessible to everyone. Through cutting-edge technology and innovative solutions, we strive to bridge the gap between patients and healthcare providers, making healthcare services more efficient, transparent, and patient-centric.
      </p><hr/>
      <h2>What We Offer</h2>
      <ul>
        <li>Easy Appointment Booking</li>
        <li>Comprehensive Provider Profiles</li>
        <li>Appointment Reminders</li>
        <li>Secure and Confidential</li>
      </ul><hr/>
      <h2>Get Started Today</h2>
      <p>
        Join thousands of satisfied users who trust XOXO HEALTHCARE to manage their healthcare needs. Whether you're scheduling a routine check-up or seeking specialized treatment, we're here to help you find the right healthcare provider, effortlessly.
      </p><hr/>
      <p>
        Experience the future of healthcare booking with XOXO—your health, simplified.
      </p>
    </div>
  );
};

export default AboutPage;
